import { atomWithSuspenseQuery } from 'jotai-tanstack-query';
import { atomWithDebounce } from '@/atoms/debounce';
import { selectedRadarTemplateIncludeParamsAtom } from '@/atoms/radar';
import { playerNormalisedAggregatesUrl } from '@/query/url';
import { Nullable } from '@/types/generic';
import { NestedObject } from '@/types/object';
import { hasEmptyInFilters } from '@/utils/api';
import { playerIdAtom } from '../../player/player';
import { fetchClientAtom } from '../client';

export const playerRadarFilterDebounceObject = atomWithDebounce<Nullable<NestedObject>>(null);
const { debouncedValueAtom: playerRadarFilterAtom } = playerRadarFilterDebounceObject;

export const rawPlayerRadarDataAtom = atomWithSuspenseQuery(get => {
  const { fetch } = get(fetchClientAtom);
  const includeParams = get(selectedRadarTemplateIncludeParamsAtom);
  const queryKey = ['playerRadarData', get(playerIdAtom), get(playerRadarFilterAtom), includeParams] as const;

  const queryFn = async ({ queryKey: [, playerId, filterParams, includeParams] }: { queryKey: typeof queryKey }) => {
    const url = playerNormalisedAggregatesUrl(playerId, { ...filterParams, ...includeParams });
    if (!url || hasEmptyInFilters(filterParams)) return {};

    return (await fetch(url)) as Promise<Record<string, number>>;
  };

  return { queryKey, queryFn };
});
